module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/HORSESHOE@2x.png?1.0.17";